import React from 'react';
import Router from '../../Router';
import './App.scss';

// import { useSelector } from 'react-redux';

function App() {
  // const isLogged = useSelector(state => state.isLogged);
  return (
    <div className="App">
      <Router />
    </div>
  );
}

export default App;
